import { motion } from 'motion/react'
import { ThumbsUpGraphics } from '~/components/graphics/thumbs-up'
import { Hero } from '~/components/hero'
import { FeatureList } from '~/features/multi-page/components/feature-list'
import { returnFromPaywall } from '~/lib/return-from-paywall'
import { m } from '~/paraglide/messages'
import { enterFrom } from '~/params'

export function MainPage(props: { next: () => void }) {
  const title = () => {
    switch (enterFrom) {
      case 'tag_list_edit':
      case 'tag_list_create':
      case 'focus_settings_create_tag':
      case 'focus_settings_favorites':
      case 'settings_custom_phrase':
        return m.subscription_cta_general_title()
      default:
        return m
          .subscription_walkthrough_p1_free_title()
          .replace('[%2$s]', 'color: #2AFD00;')
    }
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="h-full overflow-y-auto"
    >
      <div className="z-5 relative items-center px-8 pb-52 pt-[72px]">
        <div className="mx-auto flex w-full max-w-[640px] flex-col items-center gap-9">
          <div className="flex w-full flex-col items-center gap-6">
            <h1
              className="text-center text-[32px] font-bold text-white"
              style={{
                textShadow: '0px 0px 12px rgba(214, 248, 255, 0.53)',
              }}
              dangerouslySetInnerHTML={{ __html: title() }}
            />
            <Hero />
            <FeatureList />
          </div>

          {/* Note section */}
          <div className="flex w-full flex-col items-center gap-[30px]">
            <div className="h-[120px] w-[136px] bg-cover">
              <ThumbsUpGraphics />
            </div>
            <p className="text-center text-xl font-medium text-[#F9F9F9]">
              {m.onboarding_paywall_social_proof()}
            </p>
          </div>
        </div>
      </div>

      <div
        id="footer"
        className="fixed bottom-0 left-0 right-0 z-30 bg-[#001721] px-6 pb-12 pt-3 animate-in slide-in-from-bottom"
        style={{
          boxShadow: '0 -3px 3px 0 rgba(255, 255, 255, 0.20)',
        }}
      >
        <div className="mx-auto flex w-full max-w-[640px] flex-col items-center space-y-3">
          <NextButton next={props.next} />
          <button
            className="h-10 font-bold text-[#FFFFFF99]"
            onClick={() => {
              returnFromPaywall()
            }}
          >
            {m.no_thanks()}
          </button>
        </div>
      </div>
    </motion.div>
  )
}

function NextButton(props: { next: () => void }) {
  const handleClick = () => {
    props.next()
  }

  return (
    <button
      className="group h-[52px] w-full rounded-xl p-px [background-image:linear-gradient(180deg,#C5FF70_0%,#69FF78_45%,#30D3FF_100%)]"
      onClick={handleClick}
    >
      <span className="flex h-full w-full items-center justify-center rounded-[11px] font-bold text-[#176361] [background-image:linear-gradient(106deg,#C5FF70_13%,#30D3FF_97%)] group-active:[background-image:linear-gradient(90deg,#94D66E_0%,#2BB8D3_100%)]">
        {m.btn_zero_fee_trial()}
      </span>
    </button>
  )
}
